import React from 'react';
import { AuthProvider } from './AuthContext';
import { NavigationProvider } from './NavigationContext';
import { LoadingProvider } from './LoadingContext';
import { TickerProvider } from './TickerContext';

/**
 * ContextContainer - Main context wrapper for the entire application
 * This component provides all necessary context providers to the app
 */
export function ContextContainer({ children }) {
  return (
    <LoadingProvider>
      <NavigationProvider>
        <AuthProvider>
          <TickerProvider>
          {children}
          </TickerProvider>
        </AuthProvider>
      </NavigationProvider>
    </LoadingProvider>
  );
}

export default ContextContainer;
